import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Dashboard from "@/pages/Dashboard";
import MagicLogin from "@/pages/MagicLogin";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/magic-login" element={<MagicLogin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "hsl(222 16% 10%)",
            border: "1px solid hsl(222 14% 18%)",
            color: "#fff",
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
